import { Text, WarningIcon } from '@/lib'
import { differenceInCalendarDays, parseISO } from 'date-fns'
import { ReactNode } from 'react'

export const validateFields = {
  expiresAt: (
    fieldValue: string,
    t: (key: string) => string,
    styles: Record<string, string>,
  ): ReactNode | null => {
    if (!fieldValue) return null

    const today = new Date()
    const date = parseISO(fieldValue)
    const diff = differenceInCalendarDays(date, today)

    if (diff <= 1) {
      return (
        <div className={styles['warning-message']}>
          <WarningIcon />
          <Text>{t('dateTooSoonMessage')}</Text>
        </div>
      )
    }

    return null
  },
  expectedDeliveryDays: (
    fieldValue: number,
    t: (key: string) => string,
    styles: Record<string, string>,
  ): ReactNode | null => {
    if (!fieldValue) return null

    if (fieldValue <= 3) {
      return (
        <div className={styles['warning-message']}>
          <WarningIcon />
          <Text>{t('expectedDeliveryDaysToSoon')}</Text>
        </div>
      )
    }

    return null
  },
}
